"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Return the current blockquote, from current selection or from a node.
 */
var getCurrentBlockquote = function (opts) { return function (value, block) {
    var document = value.document;
    if (!block) {
        if (!value.selection.start.key) {
            return null;
        }
        block = value.startBlock;
    }
    var parent = document.getParent(block.key);
    return parent && parent.type === opts.type
        ? parent
        : null;
}; };
exports.default = getCurrentBlockquote;
//# sourceMappingURL=getCurrentBlockquote.js.map